import { apiFetch } from '../lib/apiFetch';

export interface DashboardInfo {
  id: string;
  title: string;
}

export interface DashboardsResponse {
  available: boolean;
  supersetUrl: string;
  dashboards: {
    marketing: DashboardInfo[];
    general: DashboardInfo[];
  };
}

export async function fetchGuestToken(dashboardId: string): Promise<string> {
  const res = await apiFetch('/api/v1/reports/guest-token', {
    method: 'POST',
    body: JSON.stringify({ dashboardId }),
  });
  if (!res.ok) throw new Error('Failed to fetch guest token');
  const data = await res.json();
  return data.token;
}

export async function fetchDashboards(): Promise<DashboardsResponse> {
  const res = await apiFetch('/api/v1/reports/dashboards');
  if (!res.ok) throw new Error('Failed to fetch dashboards');
  return res.json();
}
